<template>
  <el-row :gutter="20" class="h-100">
    <el-col :span="showHKControlPanel ? 14 : 24" class="h-100">
      <div :id="id" class="h-full w-full" @dblclick="wholeFullScreen"></div>
      <i class="iconfont icon-fullscreen absolute text-white" @click="wholeFullScreen"></i>
      <div id="monitorOprate" v-show="false">
        <div class="text-center">
          <img
            :disabled="!isBackPlay"
            class="controllar-image controllar-image_up"
            src="@/assets/images/video-monitor/arrows.png"
            @mousedown="controlCamera('up', 0)"
            @mouseup="controlCamera('up', 1)"
          />
        </div>
        <div class="text-center">
          <img
            class="controllar-image"
            src="@/assets/images/video-monitor/arrows.png"
            @mousedown="controlCamera('left', 0)"
            @mouseup="controlCamera('left', 1)"
          />
          <img
            class="controllar-image controllar-image_right"
            src="@/assets/images/video-monitor/arrows.png"
            @mousedown="controlCamera('right', 0)"
            @mouseup="controlCamera('right', 1)"
          />
        </div>
        <div class="text-center mb-2">
          <img
            class="controllar-image controllar-image_down"
            src="@/assets/images/video-monitor/arrows.png"
            @mousedown="controlCamera('down', 0)"
            @mouseup="controlCamera('down', 1)"
          />
        </div>
        <div class="text-center">
          <el-button
            type="primary"
            @mousedown.native="controlCamera('zoom_in', 0)"
            @mouseup.native="controlCamera('zoom_in', 1)"
            >放大</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="controlCamera('zoom_out', 0)"
            @mouseup.native="controlCamera('zoom_out', 1)"
            >缩小</el-button
          >
        </div>
      </div>
    </el-col>
    <el-col
      :span="10"
      v-if="showHKControlPanel"
      style="height: 100%"
      v-loading="isCapturePicture"
      element-loading-text="截图生成中"
    >
      <div class="pb-2 flex justify-between items-center">
        <div>云台控制</div>
        <el-button type="primary" @click="capturePicture">截图</el-button>
      </div>
      <div class="mb-2">
        <el-switch
          v-model="playType"
          active-text="历史播放"
          inactive-text="实时播放"
          @change="switchChange"
        ></el-switch>
      </div>
      <div class="mb-2" v-if="isShow">
        <el-date-picker
          class="time-width"
          v-model="playbackTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="timeChange"
        ></el-date-picker>
      </div>
      <div class="mb-2 playback-button" v-if="isShow">
        <el-button
          type="primary"
          class=""
          size="mini"
          @click="playbackStart"
          :disabled="isBackPlay"
        >
          开始回放
        </el-button>
        <el-button type="primary" size="mini" :disabled="!isBackPlay" @click="stopPlay">
          停止回放
        </el-button>
      </div>
      <div class="mb-2" v-if="isShow">
        <el-button
          v-if="isPausePlay"
          class="m-l-5"
          size="mini"
          type="primary"
          icon="iconfont el-icon-video-play"
          :disabled="!isBackPlay"
          title="播放"
          @click="playbackResume"
        ></el-button>
        <el-button
          v-if="!isPausePlay"
          class="m-l-5"
          size="mini"
          type="primary"
          icon="iconfont el-icon-video-pause"
          :disabled="!isBackPlay"
          title="暂停"
          @click="playbackPause"
        ></el-button>
        <el-button
          class="m-l-5"
          size="mini"
          type="primary"
          icon="iconfont icon-bg-backward"
          :disabled="!isBackPlay"
          title="慢放"
          @click="playbackSlow"
        ></el-button>
        <el-button
          class="m-l-5"
          size="mini"
          type="primary"
          icon="iconfont icon-bg-forward"
          :disabled="!isBackPlay"
          title="快放"
          @click="playbackFast"
        ></el-button>
      </div>
      <div class="mb-2" v-if="!isShow">
        <div class="flex justify-center">
          <img
            :disabled="!isBackPlay"
            class="controllar-image controllar-image_up"
            src="@/assets/images/video-monitor/arrows.png"
            @mousedown="controlCamera('up', 0)"
            @mouseup="controlCamera('up', 1)"
          />
        </div>
        <div class="flex justify-center items-center">
          <img
            class="controllar-image"
            src="@/assets/images/video-monitor/arrows.png"
            @mousedown="controlCamera('left', 0)"
            @mouseup="controlCamera('left', 1)"
          />
          <img
            class="controllar-image controllar-image_right"
            src="@/assets/images/video-monitor/arrows.png"
            @mousedown="controlCamera('right', 0)"
            @mouseup="controlCamera('right', 1)"
          />
        </div>
        <div class="flex justify-center mb-2">
          <img
            class="controllar-image controllar-image_down"
            src="@/assets/images/video-monitor/arrows.png"
            @mousedown="controlCamera('down', 0)"
            @mouseup="controlCamera('down', 1)"
          />
        </div>
        <div class="text-center">
          <el-button
            type="primary"
            @mousedown.native="controlCamera('zoom_in', 0)"
            @mouseup.native="controlCamera('zoom_in', 1)"
            >放大</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="controlCamera('zoom_out', 0)"
            @mouseup.native="controlCamera('zoom_out', 1)"
            >缩小</el-button
          >
        </div>
      </div>
      <div v-if="!isShow">
        <el-select
          popper-class="document_select-popper"
          v-model="speed"
          size="mini"
          placeholder="请选择云台速度"
        >
          <el-option
            v-for="item in speedOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import { BaseApi } from '@wiz-api/hik-isecure-center'

const baseApi = new BaseApi()

export default {
  props: {
    id: {
      type: String,
      default: 'hk-player',
    },
    cameraIndexCode: {
      type: String,
    },
    showHKControlPanel: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      oPlugin: null, // 播放器实例
      curIndex: 0, // 当前选中窗口下标
      iWind: 0, //
      videoUrl: '', // 视频流
      showVideo: false, // resize前需要判断是否实例化完成播放器
      isCapturePicture: false,
      isBackPlay: false,
      isPausePlay: false,
      isShow: false,
      playType: false,
      playbackTime: [],
      speed: '',
      speedOptions: [1, 20, 40, 60, 80, 100],
      playback: {
        startTime: '',
        endTime: '',
        // valueFormat: moment.HTML5_FMT.DATETIME_LOCAL_SECONDS,
        rate: '',
      },
    }
  },
  watch: {
    cameraIndexCode(val) {
      if (val) {
        if ('WebSocket' in window && this.videoUrl) {
          // 关闭上一个websocket连接
          const ws = new WebSocket(this.videoUrl)
          ws.close()
        }
        if (this.oPlugin) {
          this.stopPlay()
        }
        this.$nextTick(() => {
          this.initCamera()
        })
      }
    },
  },
  computed: {
    // 获取海康监控协议
    HKH5playerProtocol() {
      return _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["wiz-iot-management"].config.HKH5playerProtocol'
      ) || 'ws'
    },
  },
  created() {},
  mounted() {
    console.log(BaseApi.Methods, this.cameraIndexCode, '-----cameraIndexCode----')
    this.initCamera()
  },
  beforeDestroy() {
    this.stopPlay()
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.oPlugin.JS_Resize()
    },
    // 云台控制
    switchChange(val) {
      if (val) {
        // 历史回放
        this.isShow = true
        if ('WebSocket' in window && this.videoUrl) {
          // 关闭上一个websocket连接
          const ws = new WebSocket(this.videoUrl)
          ws.close()
        }
      } else {
        // 实时播放
        this.isShow = false
        this.isBackPlay = false
        this.stopPlay()
        this.initCamera()
      }
    },
    // 播放器简单配置
    initCamera() {
      this.oPlugin = new JSPlugin({
        szId: this.id, // 容器id 需要英文字母开头
        szBasePath: '/lib/video/HKh5Player/', // 资源文件
        iMaxSplit: 1, // 分屏播放，当前为1
        oStyle: {
          // 设置播放器样式
          border: '#343434',
          borderSelect: '#000',
          background: '#000',
        },
        openDebug: true,
      })
      this.initPlugin()
    },
    // 事件初始化
    initPlugin() {
      this.oPlugin.JS_SetWindowControlCallback({
        windowEventSelect(iWndIndex) {
          // 插件选中窗口回调
          this.iWind = iWndIndex
        },
        pluginErrorHandler(iWndIndex, iErrorCode, oError) {
          // 插件错误回调
          console.error(`插件错误回调   window-${iWndIndex}, errorCode: ${iErrorCode}`, oError)
        },
        windowEventOver(iWndIndex) {
          // 鼠标移过回调
          console.log('鼠标移过回调')
        },
        windowEventOut(iWndIndex) {
          // 鼠标移出回调
          console.log('鼠标移出回调')
        },
        windowEventUp(iWndIndex) {
          // 鼠标mouseup事件回调
          console.log('鼠标mouseup事件回调')
        },
        windowFullCcreenChange(bFull) {
          // 全屏切换回调
          console.log('全屏切换回调')
          // if (!that.playType || !that.showHKControlPanel) {
          //   const parentDom = document.querySelector('.sub-wnd')
          //   const childDom = document.getElementById('monitorOprate')
          //   parentDom.appendChild(childDom)
          //   childDom.style.display = bFull ? 'block' : 'none'
          // }
        },
        firstFrameDisplay(iWndIndex, iWidth, iHeight) {
          // 首帧显示回调
          console.log(iWndIndex, iWidth, iHeight)
        },
        performanceLack() {
          // 性能不足回调
          console.log('性能不足回调')
        },
      })
      this.oPlugin
        .JS_SetOptions({
          // bSupportSound: false  //是否支持音频，默认支持
          // bSupporDoubleClickFull: false  //是否双击窗口全屏，默认支持
          // bOnlySupportMSE: true  //只支持MSE
          // bOnlySupportJSDecoder: true  //只支持JSDecoder
        })
        .then(async () => {
          // 播放器实例化完成
          this.showVideo = true
          this.getWS()
        })
    },
    // 获取视频流
    async getWS() {
      const params = {
        cameraIndexCode: this.cameraIndexCode,
        streamType: 0, // 码流类型：0-主码流，1-子码流，2-第三码流，默认0
        protocol: this.HKH5playerProtocol || 'ws', // 取流协议('hik, rtsp, rtmp, hls')，默认hik
        transmode: 1, // 传输协议，0-UDP, 1-TCP, 默认TCP
        expand: 'transcode=0',
        streamform: 'ps',
      }
      const params2 = {
        url: '/artemis/api/video/v2/cameras/previewURLs',
        input: JSON.stringify(params),
      }
      console.log(params)
      const [err, res] = await baseApi.postHIK_0(params2)
      if (!err) {
        console.log(res, JSON.parse(res))
        this.videoUrl = JSON.parse(res).data.url
        this.realplay()
      }
    },
    // 播放视频
    realplay() {
      console.log(this.videoUrl, 'videoUrl-videoUrl')
      this.oPlugin
        .JS_Play(
          this.videoUrl,
          {
            playURL: this.videoUrl,
            mode: 1, // 0：普通模式   1：高级模式
          },
          this.curIndex
        )
        .then(() => {
          console.log('realplay success')
        })
        .catch(() => {
          console.log('realplay failed')
        })
    },
    // 停止播放
    // stopPlay() {
    //   this.oPlugin
    //     .JS_Stop(this.curIndex)
    //     .then(() => {
    //       console.log('JS_Stop success')
    //     })
    //     .catch(() => {
    //       console.log('JS_Stop failed')
    //     })
    // },
    // 整体全屏
    wholeFullScreen() {
      this.oPlugin.JS_FullScreenDisplay(true).then(
        () => { console.log('wholeFullScreen success') },
        (e) => { console.error(e) }
      )
    },
    // 设置窗口大小
    resizeVideo() {
      if (this.showVideo) {
        this.oPlugin
          .JS_Resize()
          .then(() => {
            console.log('resizeplay success')
          })
          .catch(() => {
            console.log('resizeplay failed')
          })
      }
    },
    fullScreen() {
      this.oPlugin
        .JS_FullScreenSingle(this.curIndex)
        .then(() => {
          console.log('JS_FullScreenDisplay success')
        })
        .catch((e) => {
          console.log(e, 'JS_FullScreenDisplay faild')
        })
    },
    // 时间段选择(转为IOS8601时间格式)
    timeChange(val) {
      const startTime = dayjs(val[0]).add(8, 'hour').format('YYYY-MM-DD HH:mm:ss')
      const endTime = dayjs(val[1]).add(8, 'hour').format('YYYY-MM-DD HH:mm:ss')
      this.playback.startTime = new Date(startTime).toISOString().replace('Z', '+08:00')
      this.playback.endTime = new Date(endTime).toISOString().replace('Z', '+08:00')
    },
    // 获取视频回放流
    async getPlaybackUrl() {
      let playUrl = ''
      const params = {
        cameraIndexCode: this.cameraIndexCode,
        recordLocation: 1, // 存储类型：0-中心存储，1-设备存储，默认0
        protocol: this.HKH5playerProtocol || 'ws', // 取流协议('hik, rtsp, rtmp, hls')，默认hik
        transmode: 1, // 传输协议，0-UDP, 1-TCP, 默认TCP
        beginTime: this.playback.startTime,
        endTime: this.playback.endTime,
        expand: 'transcode=0',
        streamform: 'ps',
        lockType: 0,
      }
      const params2 = {
        url: '/artemis/api/video/v2/cameras/playbackURLs',
        input: JSON.stringify(params),
      }
      const [err, res] = await baseApi.postHIK_0(params2)
      console.log(res, '获取回放视频流的res')
      if (!err && res) {
        playUrl = JSON.parse(res).data.url
        this.isBackPlay = true
      }
      return playUrl
    },
    // 开始回放
    async playbackStart() {
      if (!this.playbackTime.length) {
        this.$message.warning('请先选择回放时间段！')
        return
      }
      if ('WebSocket' in window && this.videoUrl) {
        // 关闭上一个websocket连接
        const ws = new WebSocket(this.videoUrl)
        ws.close()
      }
      if (this.oPlugin) {
        this.stopPlay()
      }
      const playURL = await this.getPlaybackUrl()
      const mode = 1
      const startTime = this.playback.startTime
      const endTime = this.playback.endTime

      this.oPlugin.JS_Play(playURL, { playURL, mode }, 0, startTime, endTime).then(
        () => {
          console.log('playbackStart success')
          this.playback.rate = 1
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 停止回放
    stopPlay() {
      this.isBackPlay = false
      this.isPausePlay = false
      this.oPlugin.JS_StopRealPlayAll().then(
        () => {
          this.playback.rate = 0
          console.log('JS_StopRealPlayAll success')
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 暂停
    playbackPause() {
      this.isPausePlay = !this.isPausePlay
      this.oPlugin.JS_Pause(0).then(
        () => {
          console.log('JS_Pause success')
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 播放
    playbackResume() {
      this.isPausePlay = !this.isPausePlay
      this.oPlugin.JS_Resume(0).then(
        () => {
          console.log('JS_Resume success')
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 慢放
    playbackSlow() {
      this.oPlugin.JS_Slow(0).then(
        (rate) => {
          this.playback.rate = rate
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 快放
    playbackFast() {
      this.oPlugin.JS_Fast(0).then(
        (rate) => {
          this.playback.rate = rate
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 摄像头方向控制
    async controlCamera(direction, action) {
      const params = {
        cameraIndexCode: this.cameraIndexCode,
        action,
        command: direction,
        speed: this.speed ? this.speed : '50',
      }
      const params2 = {
        url: '/artemis/api/video/v1/ptzs/controlling',
        input: JSON.stringify(params),
      }
      const [err, res] = await baseApi.postHIK_0(params2)
      if (!err) {
        console.log('摄像头操作成功！')
        const code = JSON.parse(res).code
        if (code !== '0') {
          this.$message.error(`海康设备异常状态码：${code}`)
        }
      }
      // const res = await getMonitorControlling(params)
      // if (res && res.code === '0') {
      //   console.log('摄像头操作成功！')
      // }
    },
    // 截图
    capturePicture() {
      this.isCapturePicture = true
      this.oPlugin
        .JS_CapturePicture(0, `监控截图${dayjs().format('YYYYMMDDHHmmss')}`, 'JPEG')
        .then((res) => {
          this.isCapturePicture = false
          console.log(res, '截图')
        })
        .catch(() => {
          this.isCapturePicture = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.icon-fullscreen {
  font-size: 18px;
  bottom: 10px;
  right: 25px;
}
.playback-button {
  display: flex;
  justify-content: space-around;
  button {
    width: 50%;
  }
}
.controllar-image {
  width: 30px;
  cursor: pointer;
  &_up {
    transform: rotate(90deg);
    // margin-left: 40px;
  }
  &_right {
    margin-left: 50px;
    transform: rotate(180deg);
  }
  &_down {
    transform: rotate(-90deg);
    // margin-left: 40px;
  }
}
.time-width {
  width: 100% !important;
}
#monitorOprate {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
</style>
